export const workCardMediaStyles = ['square', 'square-rounded-corners'] as const
export type WorkCardMediaStyle = (typeof workCardMediaStyles)[number]

export const workCardImageAspectRatios = ['auto', 'square'] as const
export type WorkCardImageAspectRatio = (typeof workCardImageAspectRatios)[number]

export type WorkCardArgs = {
  mediaStyle?: WorkCardMediaStyle
  imageAspectRatio?: WorkCardImageAspectRatio
  imageSrc: string
  imageAlt: string
  href: string
  isVideo?: boolean
  clientName: string
  campaignType?: string
  campaignName?: string
  views?: string
}
